import React, { useRef } from 'react'
import moment from 'moment'
import cx from 'classnames'
import Input from './Input'

const DurationInput = ({
  value,
  events = {},
  update,
  style = {},
  disabled
}) => {
  const ref = useRef(null)

  return (
    <div
      className={cx('ui gp-duration-input', { 'is-disabled': disabled })}
      style={style}
    >
      <Input
        disabled={disabled}
        reference={ref}
        placeholder='--:--'
        defaultValue={
          value
            ? `${value.hours() < 10 ? `0${value.hours()}` : value.hours()}:${
                value.minutes() < 10 ? `0${value.minutes()}` : value.minutes()
              }`
            : value
        }
        events={{
          ...events,
          onChange: (value) => {
            if (Number.isNaN(Number(value.charAt(value.length - 1)))) {
              ref.current.value = value.slice(0, -1)
            } else if (value.length <= 5) {
              let tmp = value.replace(/:/g, '').split('').reverse().join('')
              let change = `${tmp.substr(0, 2)}`
              if (tmp.length > 2) change += `:${tmp.substr(2, 2)}`
              change = change.split('').reverse().join('')

              ref.current.value = change
              update(moment.duration(change))
            } else {
              ref.current.value = value.substr(0, 5)
            }
          }
        }}
      />
    </div>
  )
}

export default DurationInput
